//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    status: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
};